import { Component, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { StorageHelper } from '@app/_helpers';
 
@Component({
  selector: 'app-risk-disclosure',
  templateUrl: './risk-disclosure.component.html',
  styleUrls: ['./risk-disclosure.component.scss']
})
export class RiskDisclosureComponent implements OnInit {
  constructor(private dialogRef: MatDialogRef<RiskDisclosureComponent>,
 
  ) { }
 
  ngOnInit(): void {
  }
 
  popupAccepted() {
    this.dialogRef.close();
    StorageHelper.popupAccepted = true;
  }
 
}
